import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import FormLayoutControls from './form-layout-controls';
import {COLUMN_DIVISOR} from 'ub/elements/form/geometry';

const formColumnContainer = document.createElement('div');

formColumnContainer.className = 'form-elm';

const updateFormColumnControls = (panel) => {
  const element = panel.element;
  const groupWidth = element.model.safeGet('geometry.field.groupWidth');
  const undoManager = element.getUndoManager();

  ReactDOM.render(
    React.createElement(FormLayoutControls, {
      fieldWidth: groupWidth || COLUMN_DIVISOR,
      onBeforeSlideChange: () => {
        undoManager.startGroup();
      },
      onSlideChange: (width) => {
        const widthAsAPercentage = COLUMN_DIVISOR / width;
        element.model.set('geometry.field.groupWidth', widthAsAPercentage, undoManager);
      },
      onAfterSlideChange: () => {
        undoManager.endGroup();
      }
    }),
    formColumnContainer
  );
};

const installFormColumnControls = (fieldAttrsPanel, panel) => {
  fieldAttrsPanel.insert(formColumnContainer);

  panel.modelChangeHandlers.push((ev) => {
    if (_.contains('geometry.field.groupWidth', ev.data.accessor)) {
      updateFormColumnControls(panel);
    }
  });
};

export default {
  installFormColumnControls,
  updateFormColumnControls
};



// WEBPACK FOOTER //
// ./src/ui/properties-panel/forms/form-option-group-columns-control.jsx